export function documentToFieldName(document: string): string {
  return document.replace(/[.-]/g, '_');
}
